import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = {
  class: "mt-4 text-center single-proced-btn",
  style: {"display":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $setup.store.showModal,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.store.showModal) = $event)),
    class: _normalizeClass(`donation-style-${($props.dstyle || 1)} ${$setup.store.config.wrapper_class}`),
    "modal-append-to-body": true,
    "append-to-body": true,
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    onClose: _cache[5] || (_cache[5] = ($event: any) => {
      _ctx.$emit('close');
    }),
    "modal-class": "wpcm-wrapper",
    "show-close": false,
    "destroy-on-close": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: "closep",
        slot: "title",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.store.showModal = false))
      }, _cache[6] || (_cache[6] = [
        _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 1024 1024"
        }, [
          _createElementVNode("path", {
            fill: "currentColor",
            d: "M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
          })
        ], -1 /* HOISTED */)
      ])),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.store.components)
          ? (_openBlock(), _createBlock($setup["ModalTemplate"], {
              key: 0,
              config: $setup.store.config,
              currentStep: $setup.store.step
            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
              _renderList($setup.groupBySlots($setup.store.components), (slotData, slot) => {
                return {
                  name: `${slot}`,
                  fn: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotData, (comp) => {
                      return (_openBlock(), _createBlock($setup["ModalView"], { comp: comp }, null, 8 /* PROPS */, ["comp"]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                }
              })
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["config", "currentStep"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_2, [
          ($setup.store.step < $setup.store.config.steps)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: _normalizeClass([$setup.store.config.proceed_classes || 'proceed btn']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.store.next()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.store.config.proceed && "Proceed"), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["class"]))
            : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                class: _normalizeClass([$setup.store.config.proceed_classes || 'proceed btn']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.submit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.store.config.donate_now), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["class"])),
          ($setup.store.step > 1 && $setup.store.config.show_back_btn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                class: _normalizeClass([$setup.store.config.proceed_classes || 'proceed btn']),
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.store.back()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.store.config.back_text && "Go Back"), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["class"]))
            : _createCommentVNode("v-if", true)
        ])
      ])), [
        [_directive_loading, $setup.store.loading]
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "class"]))
}